(function () {
    function setupCollectionSection(section) {
        if (!section) return;

        var body = section.querySelector('[data-collection-body]');
        var filterToggleBtn = section.querySelector('[data-filter-toggle]');
        var filterSidebar = section.querySelector('[data-filter-sidebar]');
        var filterOverlay = section.querySelector('[data-filter-overlay]');
        var filterCloseBtn = section.querySelector('[data-filter-close]');
        var productGrid = section.querySelector('[data-product-grid]');
        var sentinel = section.querySelector('[data-infinite-sentinel]');
        var spinner = section.querySelector('[data-infinite-spinner]');
        var mobileBreakpoint = Number(section.dataset.mobileBreakpoint || 768);
        var mobileMedia = window.matchMedia('(max-width: ' + mobileBreakpoint + 'px)');
        var observer = null;

        if (!body || !filterSidebar || !productGrid) return;

        function isMobileLayout() {
            return mobileMedia.matches;
        }

        function syncFilterState(isOpen) {
            var mobile = isMobileLayout();

            if (mobile) {
                filterSidebar.classList.toggle('mobile-open', isOpen);
                filterSidebar.classList.remove('collapsed');
                filterOverlay.hidden = !isOpen;
                filterOverlay.classList.toggle('active', isOpen);
                document.body.style.overflow = isOpen ? 'hidden' : '';
                body.classList.remove('filter-closed');
            } else {
                filterSidebar.classList.toggle('collapsed', !isOpen);
                filterSidebar.classList.remove('mobile-open');
                filterOverlay.classList.remove('active');
                filterOverlay.hidden = true;
                document.body.style.overflow = '';
                body.classList.toggle('filter-closed', !isOpen);
            }

            filterSidebar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
            if (filterToggleBtn) {
                filterToggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                filterToggleBtn.classList.toggle('is-active', isOpen && !mobile);
            }
        }

        function openFilter() {
            syncFilterState(true);
        }

        function closeFilter() {
            syncFilterState(false);
        }

        function toggleFilter() {
            var shouldOpen = isMobileLayout()
                ? !filterSidebar.classList.contains('mobile-open')
                : filterSidebar.classList.contains('collapsed');
            syncFilterState(shouldOpen);
        }

        function bindAccordion(header) {
            if (!header || header.dataset.spBound === 'true') return;
            header.dataset.spBound = 'true';

            header.addEventListener('click', function () {
                var content = header.nextElementSibling;
                if (!content) return;
                var willOpen = !header.classList.contains('open');
                header.classList.toggle('open', willOpen);
                header.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
                content.classList.toggle('open', willOpen);
            });
        }

        function initAccordions() {
            section.querySelectorAll('[data-filter-group-toggle]').forEach(bindAccordion);
        }

        function ensureCardInit() {
            if (typeof window.scpInitVendensSlider === 'function' && section.id) {
                delete section.dataset.vpsInit;
                window.scpInitVendensSlider(section.id);
            }
        }

        function ensureRevealObserver() {
            if (!window.scpCollectionRevealObserver) {
                window.scpCollectionRevealObserver = new IntersectionObserver(function (entries, revealObserver) {
                    entries.forEach(function (entry) {
                        if (!entry.isIntersecting) return;
                        entry.target.classList.add('is-visible');
                        revealObserver.unobserve(entry.target);
                    });
                }, { rootMargin: '0px 0px -50px 0px', threshold: 0.08 });
            }

            productGrid.querySelectorAll('.sp-animate-item:not(.is-visible)').forEach(function (item) {
                window.scpCollectionRevealObserver.observe(item);
            });
        }

        async function loadNextPage() {
            if (!sentinel || sentinel.dataset.loading === 'true') return;

            var nextUrl = sentinel.getAttribute('data-next-url');
            if (!nextUrl) return;

            sentinel.dataset.loading = 'true';
            if (spinner) spinner.hidden = false;

            try {
                var response = await fetch(nextUrl, { credentials: 'same-origin' });
                var html = await response.text();
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var newItems = doc.querySelectorAll('[data-product-grid] .sp-product-cell');

                if (newItems.length) {
                    var fragment = document.createDocumentFragment();
                    newItems.forEach(function (item) {
                        item.classList.add('sp-animate-item');
                        fragment.appendChild(item);
                    });
                    productGrid.appendChild(fragment);
                    ensureRevealObserver();
                    ensureCardInit();
                }

                var newSentinel = doc.querySelector('[data-infinite-sentinel]');
                if (newSentinel && newSentinel.getAttribute('data-next-url')) {
                    sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
                } else if (observer) {
                    observer.disconnect();
                    sentinel.parentElement.remove();
                }
            } catch (error) {
                console.error('Infinite scroll fetch error:', error);
            } finally {
                sentinel.dataset.loading = 'false';
                if (spinner) spinner.hidden = true;
            }
        }

        if (!section.dataset.spCollectionBound) {
            section.dataset.spCollectionBound = 'true';

            if (filterToggleBtn) {
                filterToggleBtn.addEventListener('click', toggleFilter);
            }

            if (filterCloseBtn) {
                filterCloseBtn.addEventListener('click', closeFilter);
            }

            if (filterOverlay) {
                filterOverlay.addEventListener('click', closeFilter);
            }

            section.addEventListener('submit', function (event) {
                if (isMobileLayout() && event.target && event.target.classList.contains('sp-filter-form')) {
                    closeFilter();
                }
            });

            var handleBreakpointChange = function () {
                if (isMobileLayout()) {
                    closeFilter();
                } else {
                    syncFilterState(!filterSidebar.classList.contains('collapsed'));
                }
            };

            if (typeof mobileMedia.addEventListener === 'function') {
                mobileMedia.addEventListener('change', handleBreakpointChange);
            } else if (typeof mobileMedia.addListener === 'function') {
                mobileMedia.addListener(handleBreakpointChange);
            }
        }

        initAccordions();
        ensureCardInit();
        ensureRevealObserver();
        syncFilterState(false);

        if (sentinel && !sentinel.dataset.observerBound) {
            sentinel.dataset.observerBound = 'true';
            observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        loadNextPage();
                    }
                });
            }, {
                rootMargin: '0px 0px 300px 0px',
                threshold: 0
            });
            observer.observe(sentinel);
        }
    }

    function initAllSections(root) {
        var context = root || document;
        context.querySelectorAll('.sp-collection-section, .scp-collection-section').forEach(setupCollectionSection);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initAllSections(document);
        }, { once: true });
    } else {
        initAllSections(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
        initAllSections(event.target);
    });

    document.addEventListener('vendens:collection:updated', function (event) {
        initAllSections(event.target || document);
    });

    document.addEventListener('scp:collection:updated', function (event) {
        initAllSections(event.target || document);
    });
})();
